import { usePortalImage } from '../usePortalImage.js';

/** Photo publiée (chargée avec le jeton, à la demande). */
export function PortalPhoto({
  id,
  variant,
  alt,
  className = 'aspect-square w-full object-cover',
}: {
  id: string;
  variant: 'thumb' | 'display';
  alt: string;
  className?: string;
}) {
  const { ref, src, failed } = usePortalImage(id, variant);
  return (
    <div ref={ref} className="ui-skeleton overflow-hidden rounded-lg">
      {src ? (
        <img src={src} alt={alt} className={className} />
      ) : (
        <div className={`${className} flex items-center justify-center text-xs text-ink-3`}>
          {failed ? 'Photo indisponible' : ''}
        </div>
      )}
    </div>
  );
}
